import React, { useState, useEffect, createRef, useRef, useMemo } from 'react';

import Constant from '@/common/constant/Constant';
import TelephoneConstant from '@/common/constant/TelephoneConstant';
import Utils from '@/common/utils/utils';
import {
    IconButton,
    Button,
    MenuItem,
    Popover,
    TextField,
    Dialog,
    DialogContent,
    DialogActions,
    ListSubheader,
    DialogContentText,
    Tooltip
} from '@material-ui/core';
import {
    getProjectNameOfField,
    isSystemField,
    isProjectUsingSystemForm,
    duplicateField,
    showFieldInfo,
    removeFieldInFieldList,
    onClickUsingProjects,
    onBeforeDragStartHandlerFieldList,
    onDragEndHandlerFieldList,
    getFieldListInCorp,
    onSubmitAddField,
    onSubmitTagItems,
    autoScrollToEditField,
    initObserverAddField,
    handleEventChangeFieldFilter,
    getSelectProjectList,
    deleteFieldById,
    deleteFieldByIdWithClearUnsavedChanges,
    getNewOrderForNewField,
    displayExpandField,
    isShowMCPServerField,
} from '@/component/formManagement/handler/FieldListHandler';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { fieldListOfProjectSelector } from '@/state/selector/formSelector';
import { formListOfProjectSelector } from '@/state/selector/formSelector';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { panelSettingAtom, panelStartIndexAtom } from '@/state/atom/panelAtom';
import systemField, {
    TmpHiddenSystemField,
    ForceActiveSystemFields,
    AISystemField
} from '@/common/constant/SystemField';
import { userAtom } from '@/state/atom/userAtom';
import { useSnackbar } from 'notistack';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import {
    getAddFieldByFieldType,
    isAddNewField,
    isUseFieldInForm,
    isPermissionDeleteField,
    isEditField,
    getIconFieldByTypeField,
    sortFieldListByOrder,
    sortFieldListByDictionary,
    sortProjectByprojectInuseAndDictionary,
    addFieldNew,
    closePanelFormManagement,
} from '@/component/formManagement/handler/CommonHandler';
import { cloneDeep } from 'lodash-es';
import AddFieldTagItem from './addField/AddFieldTagItem';
import AddFieldStatusItem from './addField/AddFieldStatusItem';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import ReactDOM from "react-dom";
import PropTypes from 'prop-types';
import UnsavedChangesDialog from './UnsavedChangesDialog';
import { formPanelTabCloseManagementAtom } from '@/state/atom/formAtom';
import trI18n from '@/common/utils/trI18n';
import { tr, trLabel } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

const FIELD_LIST_DISPLAY_IN_LIST_ONLY = [
    // Group 2: List only (Order: 100-199)
    'attachments',             // 添付ファイル
    'parent',                  // 親コンテンツ
    'escalationOriginCustomer', // エスカレーション元のカスタマー
    'escalationTarget',        // エスカレーション先
    'outline',                 // 概要
    'listOfSynonyms',          // 類義語一覧
    'telephone_from', // 発信者
    'telephone_to', // 受信者
]

function ConfirmDeleteFieldModal(props) {
    const handleCloseConfirmModal = () => {
        props.setMoreActionPopover(null);
        props.setIsOpenConfirmDeleteModal(false);
    };

    // Determine message based on whether there are unsaved changes
    const getConfirmMessage = () => {
        if (props.hasUnsavedChanges) {
            return trI18n('COMMSG_DELETE_FIELD_WITH_UNSAVED');
        }
        return trI18n('COMMSG025');
    };

    return (
        <Dialog
            open={props.isOpenConfirmDeleteModal}
            onClose={() => handleCloseConfirmModal()}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
            data-cy="field-list-delete-dialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">{getConfirmMessage()}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="btn-hg32 btn-handle-delete-user-agree btn-handle-delete-user-agree-important"
                    variant="contained"
                    color="default"
                    onClick={event => {
                        props.setMoreActionPopover(null);
                        props.submitConfirm();
                    }}
                    data-cy="dialog-btn-delete"
                >
                    {trI18n('COMBTN002')}
                </Button>
                <Button
                    className="btn-light btn-hg32"
                    variant="contained"
                    color="primary"
                    onClick={(event, reason) => handleCloseConfirmModal(event, reason)}
                    data-cy="dialog-btn-cancel"
                >
                    {trI18n('COMBTN007')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}


function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

FieldList.propTypes = {
    triggerReload: PropTypes.any
};
export default function FieldList(props) {
    // Subscribe to translation updates so displayed labels re-render on language change
    useTranslationSubscription();
    // item menu tabs
    const [anchorEl, setAnchorEl] = React.useState(null);
    const DONT_DISPLAY_SYS_FIELDS = [
        ...Object.values(Constant.AI_AUTO.SYSTEM_FIELD),
        ...Object.values(Constant.SD_AUTO.SYSTEM_FIELD),
        Constant.SYSTEM_FIELD.TICKET_ID,
        Constant.SYSTEM_FIELD.TICKET_TYPE,
        Constant.SYSTEM_FIELD.CHILDREN
    ]?.filter(field => !Constant.SORT_DEFAULT_SYSTEM_FIELD.includes(field))
    .concat([
        // Hide telephone_from (発信者) and telephone_to (受信者) from Field List
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.FROM,
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.TO,
        // Hide KB Knowledge fields
        Constant.SYSTEM_FIELD.KB_SHEET_NAME,
        Constant.SYSTEM_FIELD.KB_SHEET_ID,
        Constant.SYSTEM_FIELD.KB_XML,
        Constant.SYSTEM_FIELD.KB_XML_TIMESTAMP,
        // Hide hold count field
        TelephoneConstant.TELEPHONE.SYSTEM_FIELD.HOLD_COUNT
    ]);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);
    // Saved field name by id (fieldListInState = list loaded from the server)
    const savedFieldNameById = useMemo(
        () => new Map((fieldListInState || []).map(saved => [saved.id, Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, saved.name)])),
        [fieldListInState]
    );
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectDetail = useRecoilValue(projectInuseDetailAtom);
    const [useButtonCollapse, setUseButtonCollapse] = useState(true);
    const [unUseButtonCollapse, setUnUseButtonCollapse] = useState({flag: true, });

    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);

    // manager edited state form, field screen, close panel atom 
    const [formPanelTabClose, setFormPanelTabClose] = useRecoilState(formPanelTabCloseManagementAtom);
    
    // isOpenConfirmDeleteModal
    const [isOpenConfirmDeleteModal, setIsOpenConfirmDeleteModal] = useState(false);

    // dummy id of block msg
    const blockFieldListId = `dummy_${Date.now().toString()}`;
    const [newFieldId, setNewFieldId] = useState('');
    const [isAutoScrollToAddField, setIsAutoScrollToAddField] = useState(false);

    // screen name
    const [panelScreen, setPanelScreen] = useState(Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD);

    // system field list
    const [systemFieldList, setSystemFieldList] = useState(systemField);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);

    // common fieldDragDropList
    const [fieldDragDropList, setFieldDragDropList] = useState([]);

    // filter
    const [fieldFilter, setFieldFilter] = useState({
        type: 'all',
        usingForm: 'all'
    });

    // common projectList state
    const projectList = useRecoilValue(projectListInCorporationAtom);

    const [fieldRefList, setFieldRefList] = useState({});

    const [fieldList, setFieldList] = useState([]);
    const [fieldAddList, setFieldAddList] = useState([]);

    // component state
    const { enqueueSnackbar } = useSnackbar();

    // fieldType popover
    const [fieldTypePopover, setFieldTypePopover] = useState(null);
    const isOpenFieldTypePopover = Boolean(fieldTypePopover);
    const id = isOpenFieldTypePopover ? 'simple-popover' : undefined;

    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);
    const isOpenMoreActionPopover = Boolean(moreActionPopover);
    const [currentFieldSelected, setCurrentFieldSelected] = useState(null);
    //  const id = isOpenFieldTypePopover ? 'simple-popover' : undefined;

    // fieldType
    const [fieldTypeSelectedList, setFieldTypeSelectedList] = useState([]);

    // field use list
    const [fieldUseList, setFieldUseList] = useState([]);
    const [fieldSystemUseList, setFieldSystemUseList] = useState([]);
    // field unuse list
    const [fieldUnUseList, setFieldUnUseList] = useState([]);
    const prevFieldUnUseList = usePrevious(fieldUnUseList);

    const [fieldSystemUnUseList, setFieldSystemUnUseList] = useState([]);
    const [listIdOfListUseField,setListIdOfListUseField ] = useState([])

    // common form
    const formList = useRecoilValue(formListOfProjectSelector);

    // fieldListForUpdate
    const [fieldLisForUpdate, setFieldLisForUpdate] = useState({});

    const isUsingSystemFormInvite = isProjectUsingSystemForm(formList);
    const isUsingSystemFormQA = isProjectUsingSystemForm(formList, Constant.FORM_TYPE.FORM_REQ_QA);
    const isUsingSystemFormExternalDeskRequest = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_EXTERNAL_DESK
    );
    const isUsingSystemFormCustomerInvite = isProjectUsingSystemForm(
        formList,
        Constant.FORM_TYPE.FORM_REQ_INVITE_GUEST_CUSTOMER
    );

    const [currentUpdateField, setCurrentUpdateField] = useState({});

    const [parentPanelScreen, setParentPanelScreen] = useState(
        Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD
    );

    const [addFieldShow, setAddFieldShow] = useState(false);

    const [isChangeData, setIsChangeData] = useState(false);
    const [ isAllFieldValid, setIsAllFieldValid] = useState(true);

    
    const [isEditedData, setIsEditedData] = useState(false);


    
    // uef listen change data from Field Tab
    useEffect(() => {
        if (isChangeData) {
            setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        }
    }, [isChangeData, panelScreen]);


    const closePanelTab = useSetRecoilState(closePanelTabSelector);

    const [closeTabIdState, setCloseTabIdState] = useRecoilState(closeTabId);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [currentIndex, setCurrentIndex] = useRecoilState(panelStartIndexAtom);

    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);
    const [isCancelAddFieldTag, setIsCancelAddFieldTag] = useState(false);
    const [isCancelAddFieldStatus, setIsCancelAddFieldStatus] = useState(false);
    const [listCorpSharedField, setListCorpSharedField] = useState([]);
    const [triggerReload,setTriggerReload] = useState(false);
    const [listFormOfAffiliationProject,setListFormOfAffiliationProject] = useState([])
    const [isOpenPopupCannotInactiveField,setIsOpenPopupCannotInactiveField] = useState(false)

    const [popoverId, setPopoverId] = useState();
    const [paginationScroll, setPaginationScroll] = useState({from: 0, to: 15, total: 0, size: 15, originHeight: null});
 
    const argsCommon = {
        ...props,
        blockFieldListId: blockFieldListId,
        API: props?.API,
        isUsingProjectCheckbox: true,
        isIndexNumber: true,
        corporationDetail: corporationDetail,
        userDetail: userDetail,
        projectDetail: projectDetail,
        projectList: projectList,
        systemFieldList: systemFieldList,

        newFieldId: newFieldId,
        setNewFieldId: setNewFieldId,

        fieldRefList: fieldRefList,
        setFieldRefList: setFieldRefList,

        isAutoScrollToAddField: isAutoScrollToAddField,
        setIsAutoScrollToAddField: setIsAutoScrollToAddField,

        formList: formList,
        fieldListInState: fieldListInState,
        fieldList: fieldList,
        fieldAddList: fieldAddList,
        fieldTypeSelectedList: fieldTypeSelectedList,

        setIsLoading: props.setIsLoading,
        setFieldListInState: setFieldListInState,
        setFieldList: setFieldList,
        setFieldAddList: setFieldAddList,
        setFieldTypeSelectedList: setFieldTypeSelectedList,

        handleClick: handleClick,
        handleClose: handleClose,
        setCurrentFieldSelected: setCurrentFieldSelected,
        isOpenConfirmDeleteModal: isOpenConfirmDeleteModal,
        setIsOpenConfirmDeleteModal: setIsOpenConfirmDeleteModal,

        enqueueSnackbar: enqueueSnackbar,

        panelScreen,
        setPanelScreen,


        currentUpdateField: currentUpdateField,
        setCurrentUpdateField: setCurrentUpdateField,

        parentPanelScreen: parentPanelScreen,
        setParentPanelScreen: setParentPanelScreen,

        fieldUseList: fieldUseList,
        setFieldUseList: setFieldUseList,

        fieldSystemUseList: fieldSystemUseList,
        setFieldSystemUseList: setFieldSystemUseList,

        settingSlideRecoilState: settingSlideRecoilState,
        setSettingSlideRecoilState: setSettingSlideRecoilState,

        fieldDragDropList: fieldDragDropList,
        setFieldDragDropList: setFieldDragDropList,

        fieldLisForUpdate: fieldLisForUpdate,
        setFieldLisForUpdate: setFieldLisForUpdate,

        fieldFilter: fieldFilter,
        setFieldFilter: setFieldFilter,

        setSystemFieldList: setSystemFieldList,
        setFieldUnUseList: setFieldUnUseList,
        setFieldSystemUnUseList: setFieldSystemUnUseList,
        setIsChangeData: setIsChangeData,
        isChangeData: isChangeData,
        isEditedData:isEditedData,
        setIsEditedData: setIsEditedData,
        
        setIsAllFieldValid: setIsAllFieldValid,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        panelList,
        setPanelList,
        closePanelTab,
        triggerReload,
        setTriggerReload,
        listIdOfListUseField: listIdOfListUseField,
        listFormOfAffiliationProject: listFormOfAffiliationProject,
        setIsOpenPopupCannotInactiveField: setIsOpenPopupCannotInactiveField,

        setFormPanelTabClose: setFormPanelTabClose,
        isOpenUnsavedChangesDialog: props?.isOpenUnsavedChangesDialog || false,
        setIsOpenUnsavedChangesDialog: props?.setIsOpenUnsavedChangesDialog ? props?.setIsOpenUnsavedChangesDialog : () => {},
        setTabSelected: props?.setTabSelected ? props?.setTabSelected : () => {},
        tabSelected: props?.tabSelected ? props?.tabSelected : Constant.TAB_FORM_MANAGEMENT.FORM,
    };

    
    useEffect(() => {
        props.setIsLoading(true);
        getFieldListInCorp(props?.API, corporationDetail.id, projectDetail).then(list => {
            const listFields = list?.filter(field => !DONT_DISPLAY_SYS_FIELDS?.includes(field?.sysField));
            setFieldListInState(listFields);

            let listFieldShared = list.filter(
                item => item.affiliationOrganization !== corporationDetail.id
            );
            listFieldShared = listFieldShared.map((item, index) => item.affiliationOrganization);
            listFieldShared = [...new Set(listFieldShared)];

            let listCorpShared = props.allListCorp.filter(item =>
                listFieldShared.includes(item.id)
            );
            listCorpShared = Utils.sortListByNameCorpDictionaryASC(listCorpShared);
            setListCorpSharedField(listCorpShared);
            props.setIsLoading(false);
        });
    }, [corporationDetail.id, props.allListCorp, triggerReload]);

   

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (
                isChangeData ||
                (isCancelAddFieldTag &&
                    panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM) ||
                (isCancelAddFieldStatus &&
                    panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM)
            ) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    }, [closeTabIdState]);

    useEffect(() => {
        // init field drag/drop list
        let fieldDragDropListClone = fieldUseList
            .concat(fieldTypeSelectedList)
            .filter(
                field =>
                    field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                    ![...TmpHiddenSystemField, ...AISystemField].includes(field.sysField)
            );

        let map = fieldDragDropListClone.map(field => field.sysField);
        fieldDragDropListClone = fieldDragDropListClone.filter(
            (field) =>
                !(
                    !Constant.AI_TELEPHONE_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST.includes(
                        field.sysField
                    ) &&
                    field?.sysField?.startsWith(Constant.ID_PREFIX.AI_TELEPHONE_FIELD_ID_PREFIX)
                )
        );
        setFieldDragDropList(sortFieldListByOrder(fieldDragDropListClone, projectDetail));
        if (fieldDragDropList.length > 0) {
            setUseButtonCollapse(false);
        }
    }, [fieldTypeSelectedList]);
    // }, [fieldTypeSelectedList, fieldUseList]);

    useEffect(() => {
        // auto scroll to edit field
        autoScrollToEditField(argsCommon);
    }, [panelScreen, fieldRefList, currentUpdateField]);

    useEffect(() => {
        let formOfProject = [];
        argsCommon.formList?.forEach(form => {
            if (form.affiliationProject === projectDetail.id) {
                let newForm  = {...form}
                const structure = Utils.convertJSONDataToObject(form.structure);
                newForm.settingTitle = structure.formTitle;
                let listFiledIdOfTitle = [];
                if (!Utils.isEmptyArray(structure.formTitle)) {
                    structure.formTitle.forEach(field => {
                        if (!Utils.isEmptyString(field.id)) listFiledIdOfTitle.push(field.id);
                    });
                }
                newForm.listFiledIdOfTitle = listFiledIdOfTitle
                formOfProject.push(newForm);
            }
        });
        setListFormOfAffiliationProject(formOfProject);
    }, [formList, projectDetail]);

    useEffect(() => {
        // init observer auto scroll add new field
        const observerAddField = initObserverAddField(argsCommon);

        // clenaup the observer if component unmount
        return () => {
            observerAddField.disconnect();
        };
    }, [isAutoScrollToAddField]);

    // build system field
    const buildSystemField = () => {
        // field list: use, unuse
        let fieldSystemUnUseListForUpdate = [];
        let fieldSystemUseListForUpdate = [];

        // update ref list
        let refsListClone = { ...fieldRefList };

        // set isUsingProject
        let systemFieldListOfRender = cloneDeep(systemFieldList);
        systemFieldListOfRender.forEach(field => {
            if (field.usage === Constant.FORM_USAGE.FIELD) {
                refsListClone[field.id] = createRef();
                field.isUsingProject =
                    (isUsingSystemFormInvite && field.noInFormInvite) ||
                    (isUsingSystemFormQA && field.noInFormQA) ||
                    (isUsingSystemFormExternalDeskRequest && field.noInFormExternalDeskRequest) ||
                    (isUsingSystemFormCustomerInvite && field.noInFormGuestCustomerInvitation);

                // push data
                if (field.isUsingProject) {
                    fieldSystemUseListForUpdate.push(field);
                } else {
                    fieldSystemUnUseListForUpdate.push(field);
                }
            }
        });
        
        setFieldSystemUseList(fieldSystemUseListForUpdate);
        setFieldSystemUnUseList(fieldSystemUnUseListForUpdate);
    };

    useEffect(() => {
        // build system use/unuse
        buildSystemField();

        // update ref list
        let refsListClone = { ...fieldRefList };

        // set isUsingProject
        let fieldListOfRender = cloneDeep(fieldListInState);
        fieldListOfRender.forEach(field => {
            refsListClone[field.id] = createRef();

            let isUsingProject =
                !Utils.isEmptyArray(field.usingProjects) &&
                field.usingProjects.includes(projectDetail.id);
            field.isUsingProject = isUsingProject;
        });
        setFieldList(fieldListOfRender);

        if (fieldFilter?.type !== 'all' || fieldFilter?.usingForm !== 'all') {
            let cloneDeepArgsCommon = cloneDeep(argsCommon);
            cloneDeepArgsCommon.fieldListInState = fieldListOfRender;
            handleEventChangeFieldFilter(fieldFilter, cloneDeepArgsCommon);
        }

        setFieldRefList(refsListClone);
    }, [fieldListInState]);

    useEffect(() => {
        const fieldTypeSelectedListClone = [...fieldTypeSelectedList];
        // build system use/unuse
        buildSystemField();

        // field list: use, unuse
        let fieldUseListForUpdate = [];
        let fieldUnUseListForUpdate = [];
        let listIdOfUseListField = []

        // set isUsingProject
        let hiddenSystemField = [...TmpHiddenSystemField, ...AISystemField]?.filter(field => !Constant.SORT_DEFAULT_SYSTEM_FIELD.includes(field))
        // Check if MCP Server field should be visible based on multiple conditions
        const shouldShowMCP = isShowMCPServerField(corporationDetail);
        if (!shouldShowMCP) {
            hiddenSystemField.push(Constant.AI_AUTO.SYSTEM_FIELD.MCP_SERVER_SETTING);
        }
        let fieldListOfRender = cloneDeep(fieldList);
        fieldListOfRender.forEach(field => {
            let isUsingProject =
                !Utils.isEmptyArray(field.usingProjects) &&
                field.usingProjects.includes(projectDetail.id);
            field.isUsingProject = isUsingProject;

            if (field.isUsingProject) {
                fieldUseListForUpdate.push(field);
                listIdOfUseListField.push(field.id)
            } else {
                // don't put status field of other project
                if (
                    !(
                        (field.type === Constant.FORM_TYPE.FIELD_WORKFLOW &&
                            field.affiliationProject !== projectDetail.id) ||
                        (field.sysField && [...hiddenSystemField].includes(field.sysField))
                    )
                ) {
                    fieldUnUseListForUpdate.push(field);
                }
            }
        });

        fieldUseListForUpdate = sortFieldListByOrder(fieldUseListForUpdate, projectDetail);


        

        setListIdOfListUseField([...listIdOfUseListField])
        setFieldUseList(fieldUseListForUpdate);
        setFieldUnUseList(sortFieldListByDictionary(fieldUnUseListForUpdate));

        let fieldDragDropListClone = fieldUseListForUpdate
            .concat(fieldTypeSelectedListClone)
            .filter(
                field =>
                    field.definition !== Constant.FORM_DEFINITION.SYSTEM ||
                    ![...hiddenSystemField].includes(field.sysField)
            );

        fieldDragDropListClone.map(field => field.sysField);
        fieldDragDropListClone = fieldDragDropListClone.filter(
            (field) =>
                !(
                    !Constant.AI_TELEPHONE_PROMPT_SYSTEM_FIELD_DISPLAY_IN_FIELD_LIST.includes(
                        field.sysField
                    ) &&
                    field?.sysField?.startsWith(Constant.ID_PREFIX.AI_TELEPHONE_FIELD_ID_PREFIX)
                )
        );
        setFieldDragDropList(sortFieldListByOrder(fieldDragDropListClone, projectDetail));
        if (fieldDragDropList.length > 0) {
            setUseButtonCollapse(false);
        }
    }, [fieldList]);

    const checkDisableButtonSubmit = () => {  
        if (!isChangeData) {
            return true;
        }
        let isDisable = false;
        fieldAddList?.forEach(field => {
            if (!isDisable) {
                if (!Utils.isEmptyObject(field?.errors?.name)) {
                    isDisable = true;
                    return isDisable;
                }

                if (typeof field?.name === 'object') {
                    if (!field?.name?.jp?.text) {
                        isDisable = true;
                        return isDisable;
                    }
                    let validateShareRange =
                        [
                            Constant.SHARE_OPTION.SPECIFIC_ORG,
                            Constant.SHARE_OPTION.B2B_CUSTOMER_ORG,
                            Constant.SHARE_OPTION.B2B_HELPDESK_ORG
                        ].includes(field?.newShareOption) &&
                        Utils.isEmptyArray(field?.newShareRange);
                    if (validateShareRange) {
                        isDisable = true;
                        return isDisable;
                    }
                }
            }
        });

        

        return isDisable;
    }
    const hanldeUseButtonCollapse = () => {
        if (useButtonCollapse === true) {
            setUseButtonCollapse(false);
        } else {
            setUseButtonCollapse(true);
        }
    };

    const hanldeUnUseButtonCollapse = () => {
        if (unUseButtonCollapse === true) {
            setUnUseButtonCollapse(false);
        } else {
            
            setUnUseButtonCollapse(true);
            const paginationScrollClone = {...paginationScroll};
            paginationScrollClone.to = 15;
            setPaginationScroll(paginationScrollClone);
        }
    };

    const handleAddFieldShow = () => {
        if (addFieldShow === true) {
            setAddFieldShow(false);
        } else {
            setAddFieldShow(true);
        }
    };

    /** handler click field type selected */
    const onClickFieldTypeSelected = fieldType => {

        let saveOrder = getNewOrderForNewField(fieldDragDropList, projectDetail.id, fieldListInState, fieldAddList);
        let fieldId = `dummy_${Date.now().toString()}`;

        

        // init refs
        let refsListClone = cloneDeep(fieldRefList);
        refsListClone[fieldId] = createRef();
        

        // build field by fieldType
        let fieldDataInput = {
            id: fieldId,
            usingProjects: [projectDetail.id],
            // order: { [`${projectDetail.id}`]: fieldUseList.length }
            order: { [`${projectDetail.id}`]: saveOrder },
            saveOrder: { [`${projectDetail.id}`]: saveOrder }
        };
        

        ReactDOM.unstable_batchedUpdates(() => {
            setFieldTypePopover(null);

            // update new fieldId
            setNewFieldId(fieldId);

            setFieldRefList(refsListClone);

            // set auto scroll to add field
            setIsAutoScrollToAddField(true);

            setUseButtonCollapse(false);
            
            setIsChangeData(false);
            addFieldNew(fieldType, argsCommon, fieldDataInput);
        });

        setFormPanelTabClose(prev => ({...prev, isDirty: true}));
        
    };

    const getOrgName = orgId => {
        const orgDetail = props?.allListCorp?.find(org => {
            return org.id === orgId;
        });

       let orgName = Utils.isEmptyString(orgDetail?.title) ? '' : orgDetail?.title;
        return orgDetail?.active === Constant.CORPORATION_ACTIVE.BLOCK ? `${orgName} (${tr('停止中')})`: orgName;
    };

    const handleOnScroll = (e) => {
        let target = e.target;
        const paginationScrollClone = {...paginationScroll};
        const beforeBottom = target.scrollHeight - 30;
        let updateState = false;
        // if (paginationScrollClone.originHeight === null) {
        //     paginationScrollClone.originHeight = target.scrollHeight;
        //     updateState = true;
        // }
        // show before to bottom
        
        if (target.offsetHeight + target.scrollTop > beforeBottom && unUseButtonCollapse === false) {
            updateState = true;
            paginationScrollClone.to = paginationScrollClone.to + 15;
            // if (paginationScrollClone.to - paginationScrollClone.from > 50 && paginationScrollClone.to - 50 >= 0) {
            //     paginationScrollClone.from = paginationScrollClone.to - 50;
            // }
            
        } 

        // if (paginationScrollClone.originHeight + 50 > target.offsetHeight + target.scrollTop && paginationScrollClone.from > 0) {

        // }

        if (updateState) setPaginationScroll(paginationScrollClone);
    }
    const isDragDisabled = () => !(fieldFilter?.type === Constant.FILTER_FIELD_OPTION.ALL && fieldFilter?.usingForm === Constant.FILTER_FIELD_OPTION.ALL);

    const accordionUsedItemForm = () => {
        return (
            <>
                <div className="accordionContent">
                    <div className="fieldSetting"  
                    // onScroll={e => {
                    //     let isOnBottom  = e.currentTarget.scrollHeight- e.currentTarget.scrollTop === e.currentTarget.clientHeight;
                    //         if(isOnBottom){
                    //             let fieldDragDropListClone = [...fieldDragDropList,...fieldDragDropList];
                    //             setFieldDragDropList(fieldDragDropListClone)
                    //         }
                    //     }}
                        >
                        {/* field list use */}
                        {/* system field */}

                        {/* custom field */}
                        <DragDropContext
                            onDragEnd={event => !isDragDisabled() && onDragEndHandlerFieldList(event, argsCommon)}
                            onBeforeDragStart={event =>
                                !isDragDisabled() && onBeforeDragStartHandlerFieldList(event, argsCommon)
                            }
                        >
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <ul
                                        className="listForm-ul"
                                        id={blockFieldListId}
                                        ref={provided.innerRef}
                                        data-cy="field-list-active-custom"
                                    >
                                        {/**Exclude  */}
                                        {fieldDragDropList.map((field, index) => {
                                            return (
                                                <Draggable
                                                    key={field.id}
                                                    draggableId={`${field.id}`}
                                                    index={index}
                                                    isDragDisabled={isDragDisabled()}
                                                >
                                                    {(childProvided, snapshot) => {
                                                        if (snapshot.isDragging) {
                                                            childProvided.draggableProps.style.left =
                                                                'auto!important';
                                                        }
                                                        return (
                                                            <li
                                                                className={
                                                                    isUseFieldInForm(
                                                                        field,
                                                                        formList,
                                                                        argsCommon
                                                                    )
                                                                        ? 'listField-li'
                                                                        : 'listField-li background-color-usingForm'
                                                                }
                                                                id={field.id}
                                                                key={field.id}
                                                                ref={fieldRefList[field.id]}
                                                                data-cy="field-item"
                                                            >
                                                                <div
                                                                    ref={childProvided.innerRef}
                                                                    {...childProvided.draggableProps}
                                                                    {...childProvided.dragHandleProps}
                                                                    data-cy="field-list-active-custom-item"
                                                                    className={`fieldSetting-info ${isDragDisabled() ? 'cursor-default' : ''}`}
                                                                >
                                                                    {renderFieldItem(field)}
                                                                </div>
                                                            </li>
                                                        );
                                                    }}
                                                </Draggable>
                                            );
                                        })}
                                        {provided.placeholder}
                                    </ul>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </div>
                    {/* fieldSetting */}
                </div>
            </>
        );
    };

    // const isChangeFieldUnUseList = (fieldUnUseList, prevFieldUnUseList) => {
        
    // }   

    const accordionUnUsedItemForm = () => {
        
        if (unUseButtonCollapse) {
            return (
                <>
                    <div className="accordionContent"></div>
                </>
            )
        }

        return (
            <>
                <div className="accordionContent">
                    <div className="fieldSetting">
                        <ul className="listForm-ul" id={blockFieldListId}>
                            {/* render field custom list */}
                            {fieldUnUseList.map((field, index) => {
                                if (paginationScroll.to > index) {
                                    return (
                                        <>
                                            <li className={
                                                    isUseFieldInForm(field, formList, argsCommon)
                                                        ? 'listField-li'
                                                        : 'listField-li background-color-usingForm'
                                                }
                                                data-cy="field-item"
                                                key={field.id}
                                            >
                                                <div
                                                    data-cy="field-list-active-custom-item"
                                                    className="fieldSetting-info"
                                                >
                                                   {renderFieldItem(field)}
                                                </div>
                                            </li>
                                        </>
                                    );
                                }
                            })}

                            {/* render add field */}
                            {fieldTypeSelectedList.map(fieldType => {
                                return Utils.isEmptyArray(fieldType.usingProjects) ? (
                                    getAddFieldByFieldType(argsCommon, fieldType)
                                ) : (
                                    <></>
                                );
                            })}

                            {/* render field system list */}
                        </ul>
                    </div>
                    {/* fieldSetting */}
                </div>
            </>
        );
    };

    /** render field item */
    const renderFieldItem = field => {
        let isShowInDrilldown = true
        let hideInProject = Utils.convertJSONDataToObject(field.hideInProject);
        if(hideInProject){
            isShowInDrilldown = hideInProject[projectDetail.id] != 1
        };

        // Only a saved field with its saved name is sent to translation
        // (a field added / duplicated, or renamed but not saved yet, is shown as typed)
        const getFieldDisplayName = () => {
            const fieldName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, field.name);
            const isSavedName = !isAddNewField(field) && savedFieldNameById.get(field.id) === fieldName;
            return isSavedName ? trLabel(fieldName) : fieldName;
        };

        const isDisplayIconShowFieldInDrilldown = () => {
            if (isAddNewField(field)) return false;
            if (!field?.isUsingProject) return false;
            if (FIELD_LIST_DISPLAY_IN_LIST_ONLY.includes(field?.sysField)) return false;
            if (Constant.SORT_DEFAULT_SYSTEM_FIELD.includes(field?.sysField)) return true;
            if (
                ![
                    Constant.FORM_TYPE.FIELD_TAG,
                    Constant.FIELD_UI.FIELD_TAG,
                    Constant.FIELD_UI.WORKFLOW,
                    Constant.FORM_TYPE.FIELD_WORKFLOW
                ].includes(field?.type)
            ) {
                return false;
            }

            return true;
        };

        return (
            <>
                {/* expand more field */}
                {field.isShowInfo &&  getAddFieldByFieldType(argsCommon, field)}
                {/* detail field */}
                {!field.isShowInfo && (
                    <>
                        <div className="fieldSetting-thumb">
                            {/* get images by type field */}
                            <img src={`${getIconFieldByTypeField(field)}`} alt="" />
                        </div>
                        <div className="fieldSetting-cmt">
                            <div
                                className="fieldSetting-name"
                                onDoubleClick={e => {
                                    if (
                                        ([
                                            Constant.FORM_TYPE.FIELD_URL,
                                            Constant.FORM_TYPE.FIELD_IFRAME
                                        ].includes(field.type) &&
                                            !isEditField(field, argsCommon)) ||
                                        field.sysField
                                    ) {
                                        return;
                                    }
                                    // DOUBLE CLICK Event
                                    showFieldInfo(argsCommon, field);
                                }}
                            >
                                <div className="fieldSetting-tlt">
                                    <OverFlowTooltipWithTabsMui
                                        value={getFieldDisplayName()}
                                    ></OverFlowTooltipWithTabsMui>
                                </div>
                                {field?.affiliationOrganization === corporationDetail.id && (
                                    <p className="fieldSetting-text  --2">
                                        {getProjectNameOfField(field, projectList)}
                                    </p>
                                )}
                                {field?.affiliationOrganization !== corporationDetail.id && (
                                    <p className="fieldSetting-text  --3">
                                        {getOrgName(field?.affiliationOrganization)}
                                    </p>
                                )}
                                {field.isErrorValidate && (
                                    <>
                                        <br />
                                        <span className="message-error">
                                            {tr('フィールド名をご記入ください。')}
                                        </span>
                                    </>
                                )}
                            </div>
                            {
                                !isAddNewField(field) && (
                                    <div className="fieldSetting-autofill">
                                        <div
                                            className={
                                                isUseFieldInForm(field, formList, argsCommon)
                                                    ? 'fieldSetting-item'
                                                    : 'fieldSetting-item background-color-usingForm'
                                            }
                                        >
                                            {isDisplayIconShowFieldInDrilldown() && (
                                                <Tooltip
                                                    title={trI18n('LABEL-TOOLTIP-SHOW-FIELD-IN-DRILLDOWN')}
                                                    placement="bottom"
                                                    arrow
                                                >
                                                <IconButton
                                                        className="itemTools"
                                                        data-cy="item-field-icon-show-field-in-drilldown"
                                                        onClick={(event) => {
                                                            event.stopPropagation();
                                                            onClickToggleFieldVisibility(field);
                                                        }}
                                                    >
                                                        <img
                                                            src={isShowInDrilldown ? '/assets/image/eye-show.svg' : '/assets/image/eye-hide.svg'}
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                </Tooltip>
                                            )}

                                            {!field.isProjectInuse && (!isSystemField(field) || field.sysField === 'outline') &&
                                                field.definition !==
                                                    Constant.FORM_DEFINITION.SYSTEM &&
                                                field.type !==
                                                    Constant.FORM_TYPE.FIELD_WORKFLOW && (
                                                    <>
                                                        <IconButton
                                                            className="itemTools"
                                                            aria-label="more"
                                                            id="long-button"
                                                            aria-controls={
                                                                open ? 'long-menu' : undefined
                                                            }
                                                            aria-expanded={
                                                                open ? 'true' : undefined
                                                            }
                                                            aria-haspopup="true"
                                                            onClick={event => {
                                                                handleClick(event);
                                                                setMoreActionPopover(
                                                                    event.currentTarget
                                                                );
                                                                setCurrentFieldSelected(field);
                                                                setPopoverId(field.id);
                                                            }}
                                                        >
                                                            <img
                                                                src="/assets/image/icon-nav-manage.svg"
                                                                alt=""
                                                            />
                                                        </IconButton>
                                                        <Popover
                                                            className="nav-addManage"
                                                            id={open ? 'simple-popover' : undefined}
                                                            open={open && popoverId === field.id}
                                                            anchorEl={anchorEl}
                                                            onClose={handleClose}
                                                            anchorOrigin={{
                                                                vertical: 'top',
                                                                horizontal: 'right'
                                                            }}
                                                        >
                                                            <ul>
                                                                {!isAddNewField(
                                                                    currentFieldSelected
                                                                ) && (
                                                                    <li
                                                                        id={`${field.id}_duplicate`}
                                                                        onClick={e => {
                                                                            handleClose();
                                                                            setMoreActionPopover(
                                                                                null
                                                                            );
                                                                            duplicateField(
                                                                                argsCommon,
                                                                                currentFieldSelected
                                                                            );
                                                                            setIsChangeData(true);
                                                                        }}
                                                                        data-cy="item-field-icon-duplicate"
                                                                    >
                                                                        <span className="item">
                                                                            <img
                                                                                src="/assets/image/icon-copy.svg"
                                                                                alt=""
                                                                            />
                                                                        </span>
                                                                        <span className="text">
                                                                            {trI18n(
                                                                                'FIELDFORMBTN013'
                                                                            )}
                                                                        </span>
                                                                    </li>
                                                                )}

                                                                {isPermissionDeleteField(
                                                                    currentFieldSelected,
                                                                    formList,
                                                                    argsCommon
                                                                ) &&
                                                                    projectDetail.id ===
                                                                        field.affiliationProject && (
                                                                        <li
                                                                            id={`${field.id}_delete`}
                                                                            onClick={event => {
                                                                                handleClose();
                                                                                setIsOpenConfirmDeleteModal(
                                                                                    true
                                                                                );
                                                                            }}
                                                                            data-cy="item-field-icon-delete"
                                                                        >
                                                                            <span className="item">
                                                                                <img
                                                                                    src="/assets/image/icon-tabs-delete.svg"
                                                                                    alt=""
                                                                                />
                                                                            </span>
                                                                            <span className="text">
                                                                                {trI18n(
                                                                                    'USER01LB006'
                                                                                )}
                                                                            </span>
                                                                        </li>
                                                                    )}
                                                            </ul>
                                                        </Popover>
                                                    </>
                                                )}

                                            {/* bookmark unuse */}
                                            {!field.isUsingProject && (!isSystemField(field) || field.sysField === 'outline') &&
                                                !ForceActiveSystemFields.includes(
                                                    field.sysField
                                                ) && (
                                                    <IconButton
                                                        className="itemTools"
                                                        data-cy="item-field-icon-bookmark-inactive"
                                                        onClick={event =>
                                                            onClickUsingProjects(
                                                                argsCommon,
                                                                field,
                                                                true,
                                                                projectDetail
                                                            )
                                                        }
                                                    >
                                                        <img
                                                            src="/assets/image/icon-pin-outline.svg"
                                                            alt=""
                                                        />
                                                    </IconButton>
                                                )}
                                            {/* bookmark use */}
                                            {(!isSystemField(field) || field.sysField === 'outline') && renderBookmarkUsing(field)}

                                            {displayExpandField(field) && (
                                                <IconButton
                                                    className="itemTools"
                                                    onClick={e => showFieldInfo(argsCommon, field)}
                                                >
                                                    <img
                                                        src="/assets/image/icon-arrow-accordion-gray.svg"
                                                        alt=""
                                                    />
                                                </IconButton>
                                            )}
                                        </div>
                                        
                                    </div>
                                )}
                            {!isSystemField(field) && isAddNewField(field) && (
                                <div className="fieldSetting-autofill">
                                    <div
                                        className={
                                            isUseFieldInForm(field, formList, argsCommon)
                                                ? 'fieldSetting-item'
                                                : 'fieldSetting-item background-color-usingForm'
                                        }
                                        style={{ display: 'flex' }}
                                    >
                                        {/* Remove duplicate field */}
                                        {isAddNewField(field) && (
                                            <IconButton
                                                className="itemTools"
                                                onClick={event => {
                                                    removeFieldInFieldList(argsCommon, field);
                                                }}
                                            >
                                                <img
                                                    src="/assets/image/icon-tabs-delete.svg"
                                                    alt=""
                                                />
                                            </IconButton>
                                        )}

                                        <IconButton
                                            className="itemTools"
                                            onClick={e => showFieldInfo(argsCommon, field)}
                                        >
                                            <img
                                                src="/assets/image/icon-arrow-accordion-gray.svg"
                                                alt=""
                                            />
                                        </IconButton>
                                    </div>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </>
        );
    };

   
    const onClickToggleFieldVisibility = (field) => {
        let fieldListClone = cloneDeep(fieldList);
        let fieldIndex = Utils.findIndexInArrayById(field.id, fieldListClone);
        
        if (fieldIndex !== -1) {
            let hideInProject = Utils.convertJSONDataToObject(fieldListClone[fieldIndex].hideInProject) || {};
            
            hideInProject[projectDetail.id] = hideInProject[projectDetail.id] === 1 ? 0 : 1;
            
            fieldListClone[fieldIndex].hideInProject = JSON.stringify(hideInProject);
            
            setFieldList(fieldListClone);
            setIsChangeData(true);
            setIsEditedData(true);
            
            let fieldAddListClone = cloneDeep(fieldAddList);
            let addFieldIndex = Utils.findIndexInArrayById(field.id, fieldAddListClone);
            
            if (addFieldIndex !== -1) {
                fieldAddListClone[addFieldIndex].hideInProject = JSON.stringify(hideInProject);
                setFieldAddList(fieldAddListClone);
            } else {

                let newFieldForAdd = cloneDeep(fieldListClone[fieldIndex]);
                fieldAddListClone.push(newFieldForAdd);
                setFieldAddList(fieldAddListClone);
            }
        }
    };

    const renderBookmarkUsing = field => {
        if (
            field.isUsingProject &&
            !ForceActiveSystemFields.includes(field.sysField) &&
            field.type !== Constant.FORM_TYPE.FIELD_WORKFLOW &&
            !ForceActiveSystemFields.includes(field.sysField)
        ) {
            return (
                <IconButton
                    className="itemTools"
                    data-cy="item-field-icon-bookmark-active"
                    onClick={event => onClickUsingProjects(argsCommon, field, false, projectDetail)}
                >
                    <img src="/assets/image/icon-pin.svg" alt="" />
                </IconButton>
            );
        }
        return <></>;
    };


    const renderHeader = () => {
        return (
            <>
                <div className="headManage">
                    <div className="headManage-top">
                        <h2 className="headManage-title">{tr('フィールド一覧')}</h2>
                        <div className="headManage-tools">
                            <div className="headManage-item">
                                {/* <IconButton className="itemTools">
                                    <img src="/assets/image/icon-up.svg" alt="" />
                                </IconButton>
                                <IconButton className="itemTools">
                                    <img src="/assets/image/icon-dow.svg" alt="" />
                                </IconButton> */}
                            </div>
                            <div className="keep">
                                <Button
                                    className="btn-primary btn-hg32"
                                    data-cy="field-list-btn-submit"
                                    variant="contained"
                                    onClick={event => {
                                        onSubmitAddField(argsCommon);
                                        setFormPanelTabClose(prev => ({...prev, isDirty: false}));
                                        handleClose();
                                    }}
                                    disabled={checkDisableButtonSubmit()}
                                >
                                    {tr('保存')}
                                </Button>
                            </div>
                        </div>
                    </div>
                    {/* headManage-top */}
                    {/* formSearch formSearch--col3 */}
                    <div className="formSearch formSearch--col2">
                        <div className="formSearch-info">
                            <label className="formSearch-label">{tr('定義')}</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={event => {
                                        let fieldFilterClone = cloneDeep(fieldFilter);
                                        fieldFilterClone.type = event.target.value;
                                        setFieldFilter(fieldFilterClone);
                                        handleEventChangeFieldFilter(fieldFilterClone, argsCommon);
                                    }}
                                    value={fieldFilter.type}
                                >
                                    <MenuItem value="all">{tr('全て')}</MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SYSTEM}>
                                        {tr('システム')}
                                    </MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SAMPLE}>
                                        SysAdmin
                                    </MenuItem>
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {trI18n('FIELDFORMLB044')}
                                    </ListSubheader>
                                    {projectList &&
                                        sortProjectByprojectInuseAndDictionary(
                                            projectDetail,
                                            getSelectProjectList(projectList)
                                        ).map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                {Utils.getTextByLanguage(
                                                    Constant.LANGUAGE_TYPE.JP,
                                                    item.name
                                                )}
                                            </MenuItem>
                                        ))}
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {trI18n('FIELDFORMLB045')}
                                    </ListSubheader>
                                    {listCorpSharedField &&
                                        listCorpSharedField.map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <OverFlowTooltipWithTabsMui value={item.title} />
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </div>
                        </div>
                        <div className="formSearch-info">
                            <label className="formSearch-label">{tr('利用状況')}</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                    onChange={event => {
                                        let fieldFilterClone = cloneDeep(fieldFilter);
                                        fieldFilterClone.usingForm = event.target.value;
                                        setFieldFilter(fieldFilterClone);
                                        handleEventChangeFieldFilter(fieldFilterClone, argsCommon);
                                    }}
                                    value={fieldFilter.usingForm}
                                >
                                    <MenuItem value="all">{tr('全て')}</MenuItem>
                                    <MenuItem value="use">{tr('使用中')}</MenuItem>
                                    <MenuItem value="unuse">{tr('不使用')}</MenuItem>
                                </TextField>
                            </div>
                        </div>
                    </div>
                    {/* formSearch formSearch--col2 */}
                </div>
            </>
        );
    };

    const renderList = () => {
        return (
            <>
                {/* <div className="contentManage"  onScroll={e => handleOnScroll(e)}> */}
                    <div className={addFieldShow ? 'addField addField--show' : 'addField'}>
                        {/* Khi click vào 'div addField-accordion' thì 'div addField sẽ add addField--show' */}
                        <div className="addField-accordion">
                            <span onClick={handleAddFieldShow}>{tr('フィールドを追加')}</span>
                        </div>
                        <div className="addField-content">
                            <p className="fieldType">{tr('フィールドタイプを選択')}</p>
                            <ul>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.TAG);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{trI18n('TAG_TITLE')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.DATE);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field01.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('時間')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.TEXT);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field02.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('テキスト')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.NUMBER);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field03.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('数字')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e =>
                                        onClickFieldTypeSelected(Constant.FIELD_UI.IFRAME)
                                    }
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field05.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('iFrame')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.URL);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field06.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('URL')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.FIELD_RICHTEXT);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/icon-field07.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{tr('リッチテキスト')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.MERMAID);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/mermaid-icon.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{trI18n('MERMAID')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.HTML);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/html-icon.svg" alt="" />
                                        </span>
                                        <span className="addField-text">{trI18n('HTML')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.MARKDOWN);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/markdown-field-icon.svg" alt="" style={{ width: '24px', height: '24px' }} />
                                        </span>
                                        <span className="addField-text">{trI18n('MARKDOWN')}</span>
                                    </div>
                                </li>
                                <li
                                    onClick={e => {
                                        onClickFieldTypeSelected(Constant.FIELD_UI.JSON);
                                    }}
                                >
                                    <div className="addField-info">
                                        <span className="addField-item">
                                            <img src="/assets/image/json-field-icon.svg" alt="" style={{ width: '24px', height: '24px' }} />
                                        </span>
                                        <span className="addField-text">{trI18n('JSON')}</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    {/* addField */}
                    <div
                        className={
                            !useButtonCollapse
                                ? 'accordionForm accordionForm--show'
                                : 'accordionForm'
                        }
                    >
                        <div className="accordionHead" onClick={hanldeUseButtonCollapse}>
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">
                                {tr('以下のフィールドは使用する')} ({fieldDragDropList.length})
                            </span>
                        </div>
                        {/* Khi click vào 'div accordionHead' thì 'div accordionForm sẽ add accordionForm--show' */}

                        {accordionUsedItemForm()}
                    </div>
                    
                      <div
                        className={
                            !unUseButtonCollapse
                                ? 'accordionForm accordionForm--show'
                                : 'accordionForm'
                        }
                    >
                        
                        <div className="accordionHead" onClick={hanldeUnUseButtonCollapse}>
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin-outline.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">
                                {tr('以下のフィールドは使用しない')} ({fieldUnUseList.length})
                            </span>
                        </div>
                        {accordionUnUsedItemForm()}
                    </div>
                {/* </div> */}
            </>
        );
    };

    const callbackAddFieldTag = isCancel => {
        setIsCancelAddFieldTag(isCancel);
    };

    const callbackAddFieldStatus = isCancel => {
        setIsCancelAddFieldStatus(isCancel);
    };

    return (
        <div className="groupManage">
            {/* headManage */}
            {![
                Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM,
                Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM
            ].includes(panelScreen) && (
                renderHeader()
            )}

            {/* contentManage */}
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD && (
                <>
                    <div className="contentManage"  onScroll={e => handleOnScroll(e)}>
                        {renderList()}
                    </div>
                    {/* confirm dialog */}
                    <UnsavedChangesDialog
                        isOpen={props?.isOpenUnsavedChangesDialog}
                        messageConfirm={
                            formPanelTabClose.isClosePanel
                                ? trI18n('MSG-CONFIRM-CLOSE-PANEL')
                                : trI18n('MSG-CM-CONFIRM-CANCEL-FORM-FIELD-CHANGE')
                        }
                        closeCallBack={() => {
                            props?.setIsOpenUnsavedChangesDialog(false);
                            setFormPanelTabClose({
                                isDirty: false,
                                isClosePanel: false,
                                isCloseScreen: false,
                            });
                            if (formPanelTabClose.isClosePanel) {
                                closePanelFormManagement({panelList, setPanelList, currentIndex, setCurrentIndex});
                                return;
                            }
                            props?.setTabSelected(Constant.TAB_FORM_MANAGEMENT.FORM);
                        }}
                        closeBtnText={trI18n('OK')}
                        cancelCallBack={() => {
                            props?.setIsOpenUnsavedChangesDialog(false);
                            setFormPanelTabClose(prev => ({
                                ...prev,
                                isClosePanel: false,
                                isCloseScreen: false,
                            }));
                        }}
                        cancelBtnText={trI18n('CANCEL')}
                    />
                </>
            )}
            
            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_TAG_ITEM && (
                <AddFieldTagItem
                    {...argsCommon}
                    parentCallback={callbackAddFieldTag}
                    triggerReloadTagItem={
                        Number(triggerReload || 0) > Number(props?.triggerReload || 0)
                            ? Number(triggerReload)
                            : Number(props?.triggerReload)
                    }
                    DONT_DISPLAY_SYS_FIELDS={DONT_DISPLAY_SYS_FIELDS}
                    onClickEditTagField={() => {
                        onSubmitTagItems(argsCommon);
                    }}
                />
            )}

            {panelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM && (
                <AddFieldStatusItem {...argsCommon} parentCallback={callbackAddFieldStatus} />
            )}

            <ConfirmDeleteFieldModal
                setMoreActionPopover={setMoreActionPopover}
                isOpenConfirmDeleteModal={isOpenConfirmDeleteModal}
                setIsOpenConfirmDeleteModal={setIsOpenConfirmDeleteModal}
                hasUnsavedChanges={isChangeData}
                submitConfirm={() => {
                    // close confirm delete modal
                    setIsOpenConfirmDeleteModal(false);
                    if (isChangeData) {
                        // Case 2: Has unsaved changes → delete field + clear all unsaved changes
                        deleteFieldByIdWithClearUnsavedChanges(currentFieldSelected, argsCommon);
                    } else {
                        // Case 1: No unsaved changes → delete field as current flow
                        deleteFieldById(currentFieldSelected, argsCommon);
                    }
                }}
            />
            <CancelTabsDialog argsAll={argsCommon} />
            <Dialog
            open={isOpenPopupCannotInactiveField}
            onClose={() => setIsOpenPopupCannotInactiveField(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                className="alert-dialog-delete-addition-user"
            >
                <DialogContent>
                    <DialogContentText id="alert-dialog-delete-addition-user-content">
                    {tr('このフィールドはあるフォーマットにタイトルに設定していますので、削除もしくは使用しない事ができません。')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="confirm-delete-user-dialog-action">
                    <Button
                        onClick={() => setIsOpenPopupCannotInactiveField(false)}
                        autoFocus
                        className="btn-handle-delete-user btn-handle-delete-user-agree"
                    >
                    {tr('閉じる')}
                    </Button>
                    
                </DialogActions>
            </Dialog>
        </div>
    );
}
